import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import TRFlag from "country-flag-icons/react/3x2/TR";
import GBFlag from "country-flag-icons/react/3x2/GB";

export default function LanguageDropdown({ lang, setLang }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  // dışarı tıklayınca kapansın
  useEffect(() => {
    const onDown = (e) => {
      if (!wrapperRef.current) return;
      if (!wrapperRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  // ESC ile kapansın
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  const current =
    lang === "TR"
      ? { Flag: TRFlag, code: "TR" }
      : { Flag: GBFlag, code: "EN" };

  const other =
    lang === "TR"
      ? { Flag: GBFlag, code: "EN", value: "EN" }
      : { Flag: TRFlag, code: "TR", value: "TR" };

  const CurrentFlag = current.Flag;
  const OtherFlag = other.Flag;


  return (
    <div className="lang-dd" ref={wrapperRef}>
      <button
        type="button"
        className={`lang-dd__trigger ${open ? "is-open" : ""}`}
        aria-label="Dil seçimi"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="lang-dd__flag" aria-hidden="true">
          <CurrentFlag />
        </span>
        <span className="lang-dd__code">{current.code}</span>
        <ChevronDown className="lang-dd__chev" size={16} aria-hidden="true" />
      </button>

      {open && (
        <div className="lang-dd__menu" role="menu">
          <button
            type="button"
            role="menuitem"
            className="lang-dd__item"
            onClick={() => {
              setLang(other.value);
              setOpen(false);
            }}
          >
            <span className="lang-dd__flag" aria-hidden="true">
              <OtherFlag />
            </span>
            <span className="lang-dd__code">{other.code}</span>
          </button>
        </div>
      )}
    </div>
  );
}